import { render, staticRenderFns } from "./Merchandise.vue?vue&type=template&id=21b17028&scoped=true&"
import script from "./Merchandise.vue?vue&type=script&lang=js&"
export * from "./Merchandise.vue?vue&type=script&lang=js&"
import style0 from "./Merchandise.vue?vue&type=style&index=0&id=21b17028&prod&scoped=true&lang=css&"
import style1 from "./Merchandise.vue?vue&type=style&index=1&id=21b17028&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b17028",
  null
  
)

export default component.exports